export const CONDITION_LABELS = {
  'MINT': 'Mint',
  'NM': 'NM',
  'LP': 'LP',
  'MP': 'MP',
  'HP': 'HP',
  'DAMAGED': 'Damaged',
};

export const CONDITION_COLORS = {
  'MINT': '#2ecc71',
  'NM': '#27ae60',
  'LP': '#f1c40f',
  'MP': '#e67e22',
  'HP': '#e74c3c',
  'DAMAGED': '#c0392b',
};

export const RARITY_ORDER = {
  'common': 0,
  'uncommon': 1,
  'rare': 2,
  'mythic': 3,
};

export const CONDITION_ORDER = {
  'MINT': 0,
  'NM': 1,
  'LP': 2,
  'MP': 3,
  'HP': 4,
  'DAMAGED': 5,
};

export const FINISH_ORDER = {
  'nonfoil': 0,
  'foil': 1,
  'etched': 2,
};

export const FINISH_LABELS = {
  'nonfoil': 'Non-Foil',
  'foil': 'Foil',
  'etched': 'Etched',
};

export const FINISH_COLORS = {
  'nonfoil': '#aaa',
  'foil': '#f39c12',
  'etched': '#9b59b6',
};

export const PROXY_BADGE_COLOR = '#f39c12';
